import { Component, OnInit } from '@angular/core';
// lightgallery plugins
import 'lg-zoom.js';
import 'lg-share.js';
import 'lg-video.js';
import 'lg-pager.js';
import 'lg-autoplay.js';
import 'lg-fullscreen.js';
import 'lg-hash.js';
import 'lg-thumbnail.js';

declare var lightGallery: any;

@Component({
  selector: 'app-guest-lecturer',
  templateUrl: './guest-lecturer.component.html',
  styleUrls: ['./guest-lecturer.component.scss']
})
export class GuestLecturerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  ngAfterViewInit(): void {

    // 🎥 video galleries
    const videoGalleries = document.querySelectorAll<HTMLElement>('.video-gallery');
    videoGalleries.forEach((gallery, i) => {
      gallery.id = 'gal' + i;
      lightGallery(gallery, {
        selector: 'a',
        zoom: true,          // ✅ enable zoom
        download: false,
        thumbnail: true
      });
    });

    // 🖼️ image galleries
    const imageGalleries = document.querySelectorAll<HTMLElement>('.lightgallery');
    imageGalleries.forEach(gallery => {
      lightGallery(gallery, {
        selector: 'li',      // ✅ use li since data-src is on li
        zoom: true,          // ✅ enable zoom
        download: false,
        thumbnail: true
      });
    });
  }

}
